module.exports = __webpack_public_path__ + "images/backgrounds/dew/large.5b5f4c5cd0d7e144e401.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/dew/large.jpg
// module id = 3tps
// module chunks = 1